import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetUserAssessmentReportRequestObjectType,
  GetUserAssessmentReportResponseType
} from '../../../services/NwApplicationServices/APIService/types';

import { useNwApplicationServicePublic } from '../useNwApplicationServicePublic';

interface UseGetUserAssessmentReportApiInterface {
  getUserAssessmentReportApi: UseMutateAsyncFunction<
    GetUserAssessmentReportResponseType,
    Error,
    GetUserAssessmentReportRequestObjectType
  >;
  error: string | null;
  status: MutationStatus;
}

const useGetUserAssessmentReportApi =
  (): UseGetUserAssessmentReportApiInterface => {
    const { nwApplicationPublicService } = useNwApplicationServicePublic();

    const getUserAssessmentReport = (
      requestObject: GetUserAssessmentReportRequestObjectType
    ) => {
      return nwApplicationPublicService.getUserAssessmentReport(requestObject);
    };

    const { mutateAsync, error, status } = useMutation(
      getUserAssessmentReport,
      {
        mutationKey: ['getUserAssessmentReportApi']
      }
    );

    return {
      getUserAssessmentReportApi: mutateAsync,
      error: error ? getAPIErrorMessage(error) : null,
      status
    };
  };

export { useGetUserAssessmentReportApi };
